import DialogAlertErrorSimple from "components/DialogAlertErrorSimple/v2";

const DialogErrorForFutureReservationsInEdition = ({ dialog }) => {
	return (
		<DialogAlertErrorSimple
			dialog={dialog}
			title="No se puede realizar el cambio"
			content="Actualmente el espacio cuenta con alguna(s) reserva de alumnos activa. Para modificar el aforo, debes asegurarte que no exista ninguna reserva vigente o futura." />
	);
}

export default DialogErrorForFutureReservationsInEdition;